<mat-icon class="icon">{{ icon() }}</mat-icon>
<div class="flex flex-col gap-2">
  @if (heading()) {
    <b class="heading" [attr.data-test-id]="partTestId('title')">
      {{ heading() }}
    </b>
  }
  <span [attr.data-test-id]="partTestId('message')">
    <ng-content />
  </span>
</div>
@if (dismissible()) {
  <mat-icon
    class="close"
    [attr.data-test-id]="partTestId('close')"
    (click)="dismiss.emit()"
  >
    close
  </mat-icon>
}
